import { useEffect, useState } from "react";
// Adaptive GNB color scheme: observes [data-gnb-scheme] sections; applies the
// scheme of the section currently under the (~80px) header. Defaults to light.
export function useGnbScheme(headerRef) {
  const [scheme, setScheme] = useState("light");
  useEffect(() => {
    const el = headerRef.current;
    const sections = document.querySelectorAll("[data-gnb-scheme]");
    if (!el || !sections.length) { setScheme("light"); return; }
    const apply = (s) => { setScheme(s); el.dataset.scheme = s; };
    apply("light");
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) apply(e.target.dataset.gnbScheme || "light"); });
    }, { rootMargin: "-80px 0px -90% 0px" });
    sections.forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, [headerRef]);
  return scheme;
}
